import { createSlice } from "@reduxjs/toolkit";
import { fetchFaqsItems } from "./FaqsThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const faqsSlice = createSlice({
  name: "faqs",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchFaqsItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFaqsItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchFaqsItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default faqsSlice.reducer;